import { loadSpinner, stopSpinner } from '/source/_patterns/01-components/spinner/spinner';
import * as cartService from '/source/js/services/cartService';
import * as toastUtil from '/source/js/utils/toastUtil';
import * as qsUtil from '/source/js/utils/qsUtil';
import * as crossSellService from '/source/_patterns/01-components/plp/crossSellService';
import { getFractionCurrencyFormatter, getCurrencyFormatter } from '/source/js/utils/marketUtil';
import {setDataForAllProducts, addGtmTagToCart} from '/source/js/gtm/IsaGtmCommerce';
import { hideCartModalShoppingContext } from '/source/_patterns/01-components/cart-ribbon/cart-ribbon';

let marketSettings = window.algoliaData?.currentMarketSettingsContext; // eslint-disable-line
let currencyFormatter;
let fractionCurrencyFormatter;

function addGtmTagToAddToCart() {
    if(!window.ga_props) return;

    let lastEvent = window.ga_props[window.ga_props.length - 1];
    console.log(lastEvent);
    if(!lastEvent) return;
    var memberId = lastEvent.MemberId;
    var memberType = lastEvent.MemberType;
    var currency = lastEvent.Currency;
    var cultureCode = lastEvent.CultureCode;
    var catalog = lastEvent.CatalogName;
    var category = lastEvent.Products[0].ProductFamilyName;
    var marketingCloudUserId = lastEvent.Products[0].MarketingCloudUserId;
    var isagenixMemberSubType = lastEvent.IsagenixMemberSubType;
    var preferredCultureCode = lastEvent.PreferredCultureCode;
    var hasAutoship = lastEvent.HasAutoship;
    var canEnroll = lastEvent.CanEnroll;
    var hasIsaDelivery = lastEvent.HasIsaDelivery;
    var daysSinceEnrollment = lastEvent.DaysSinceEnrollment;
    setDataForAllProducts(catalog, category, currency, memberType, memberId, cultureCode, marketingCloudUserId, isagenixMemberSubType, preferredCultureCode, hasAutoship, canEnroll, hasIsaDelivery, daysSinceEnrollment);

    console.log(lastEvent);
    var products = {
        'name': lastEvent.Products[0].ProductName,
        'id': lastEvent.Products[0].Sku,
        'price': lastEvent.Products[0].Price, // need to get the selected price
        'brand': lastEvent.Products[0].Brand,
        'category': lastEvent.Products[0].ProductFamilyName,
        'quantity': lastEvent.Products[0].Quantity
    };

    addGtmTagToCart(products);
}

function initCurrencyFormatter() {
    fractionCurrencyFormatter = getFractionCurrencyFormatter(marketSettings);
    currencyFormatter = getCurrencyFormatter(marketSettings);
}

function showCartItemAdded(result, quantity) {
    $('.cartModal .isa-modal__product-name').text(result.Name || result.ProductName);
    let $productMeta = $('.cartModal .isa-modal__product-meta');
    let $productImage = $('.isa-modal__product-image');
    $productMeta.empty();
    let $modalBlock = $('.cross-sell-modal');
    $modalBlock.empty();

    if(result.ProductImage) {
        $productImage.attr('src', result.ProductImage);
    }

    if(result.ProductFacetList && result.ProductFacetList.length) {
        result.ProductFacetList.forEach(function (facet) {
            if(facet.Value) {
                $productMeta.append(`<div class="isa-modal__product-meta-item" >
                <div><span>${facet.Name}:</span></div>
                <div><span style="font-weight: bold; word-wrap: break-word">${facet.Value}</span></div>
                </div>`);
            }
        });
    } else if(result.Facets && result.Facets.length) {
        result.Facets.forEach(function(facet) {
            if(facet.Value) {
                $productMeta.append(`<div class="isa-modal__product-meta-item" >
                <div><span>${facet.Name}:</span></div>
                <div><span style="font-weight: bold; word-wrap: break-word">${facet.Value}</span></div>
                </div>`);
            }
        });
    }

    let $qtyText = $('#hdnQuantityText').val();
    $productMeta.append(`<div class="isa-modal__product-meta-item" >
        <div><span>${$qtyText}:</span></div>
        <div><span style="font-weight: bold; word-wrap: break-word">${quantity}</span></div>
        </div>`);

    if(marketSettings.CurrencySymbolAbbreviation) {
        if(result.Subtotal % 1 === 0) {
            $('.isa-modal__cart-total').text(currencyFormatter.format(result.Subtotal).replace(marketSettings.Currency, marketSettings.CurrencySymbolAbbreviation.trim()));
        } else {
            $('.isa-modal__cart-total').text(fractionCurrencyFormatter.format(result.Subtotal).replace(marketSettings.Currency, marketSettings.CurrencySymbolAbbreviation.trim()));
        }
    } else {
        if(result.Subtotal % 1 === 0) {
            $('.isa-modal__cart-total').text(currencyFormatter.format(result.Subtotal));
        } else {
            $('.isa-modal__cart-total').text(fractionCurrencyFormatter.format(result.Subtotal));
        }
    }
    crossSellService.updateSubHeader(result);
    crossSellService.updateCrossSellCards(result);
    $('.cartModal').modal('show');
}

function addToCartFailed(result) {
    let msg = '';
    if(result.Messages) {
        let msgo = result.Messages.find(msg => msg.DisplayMessage === true);
        if(!msgo) msgo = result.Messages[0];
        if(msgo) msg = msgo.MessageText;
    }
    if(result.ErrorCode && result.Message) msg = result.Message;
    showErrorMessage(msg);
}

function showErrorMessage(text) {
    toastUtil.Error(text);
    console.error(text);
}

async function addToCart(event) {
    let $currentTarget = $(event.currentTarget);
    let $parentElement = $currentTarget.closest('.featured-category__product-tile, .featured-category__left-column-info');
    let $productData = $parentElement.data('product');
    let $qtySelectedValue = $parentElement.find('.featured-category__mobile-qty-selector').find('.quantity-input').val();

    event.preventDefault();
    initCurrencyFormatter();
    loadSpinner();

    try {
        const result = await cartService.addToCart({
            FamilyId: $productData.FamilyId,
            FamilyName: $productData.FamilyName,
            ProductId: `Isagenix_Master|${$productData.ProductId}|`,
            Quantity: $qtySelectedValue,
            ProductPageRelativeUrl: $productData.ProductPageRelativeUrl,
            PriceType: $productData.PriceType,
            TryOnce: false,
            IsQuickAdd: true
        });

        if(result.IsSuccessful) {
            stopSpinner();
            cartService.updateQSForMergeCart();
            hideCartModalShoppingContext($productData.PriceType);
            showCartItemAdded(result, $qtySelectedValue);
        } else {
            stopSpinner();
            console.error(result);
            addToCartFailed(result);
        }
    } catch (ex) {
        console.error(ex);
        stopSpinner();
    }

    addGtmTagToAddToCart();
}

async function buildMyPack(event) {
    let $currentTarget = $(event.currentTarget);
    let $parentElement = $currentTarget.closest('.featured-category__product-tile, .featured-category__left-column-info');
    let $productData = $parentElement.data('product');
    let $qtySelectedValue = $parentElement.find('.featured-category__mobile-qty-selector').find('.quantity-input').val();

    let href = qsUtil.addUrlQuerystring($productData.ProductPageRelativeUrl, 'open', '1');
    window.location.href = qsUtil.addUrlQuerystring(href, 'isquickadd', $qtySelectedValue);
}

function increaseItems(event) {
    let $currentTarget = $(event.currentTarget);
    let input = $currentTarget.siblings('.quantity-input');
    let inputValue = input.val();
    let max = parseInt(input.attr('max'));
    let min = parseInt(input.attr('min'));
    let minusBtn = $currentTarget.siblings('.decrease-items');
    let value;

    if(inputValue !== '') {
        value = parseInt(inputValue);
    } else {
        return;
    }

    $currentTarget.prop('disabled', false);

    if(value < max) {
        value = value + 1;
    }

    if(value === max) {
        $currentTarget.prop('disabled', true);
    }

    if(value > min) {
        minusBtn.prop('disabled', false);
    }

    input.val(value);
}

function decreaseItems(event) {
    let $currentTarget = $(event.currentTarget);
    let input = $currentTarget.siblings('.quantity-input');
    let inputValue = input.val();
    let min = parseInt(input.attr('min'));
    let max = parseInt(input.attr('max'));
    let addBtn = $currentTarget.siblings('.increase-items');
    let value;

    if(inputValue !== '') {
        value = parseInt(inputValue);
    } else {
        return;
    }

    $currentTarget.prop('disabled', false);

    if(value > min) {
        value = value - 1;
    }

    if(value === min) {
        $currentTarget.prop('disabled', true);
    }

    if(value < max) {
        addBtn.prop('disabled', false);
    }

    input.val(value);
}

function checkMaxValue(event) {
    let $currentTarget = $(event.currentTarget);
    let $maxQuantity = $currentTarget.attr('max');
    let $currentValue = $currentTarget.val();

    if($maxQuantity && $currentValue) {
        $maxQuantity = parseInt($maxQuantity);
        $currentValue = parseInt($currentValue);
    }

    if($currentValue > $maxQuantity) {
        $currentValue = $maxQuantity;
    }

    $currentTarget.val($currentValue);
}

function initEventHandlers() {
    let $addToCartBtn = $('.featured-category__cta-btn.addToCart');
    let $buildMyPackBtn = $('.featured-category__cta-btn.buildPack');
    let $productQtySelector = $('.featured-category__mobile-qty-selector');
    let $priceQuantityInput = $productQtySelector.find('.price__quantity-sign');

    $productQtySelector.on('click', '.increase-items', increaseItems);
    $productQtySelector.on('click', '.decrease-items', decreaseItems);
    $priceQuantityInput.on('change', checkMaxValue);
    $addToCartBtn.on('click', addToCart);
    $buildMyPackBtn.on('click', buildMyPack);
}

$(function () {
    initEventHandlers();
});
